<template>
    <div class="flex flex-col items-center justify-center min-h-[70vh] text-center p-6">
        <Vue3Lottie 
                :animationData="lottieBg" 
                :height="'50%'" 
                :width="'50%'"
                :loop="true"
                :autoplay="true"
            />
        <h1 class="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-2">
            Module Under Development
        </h1>
        <p class="text-slate-500 dark:text-slate-400 max-w-md mb-6">
            The route <code
                class="px-2 py-1 bg-slate-200 dark:bg-slate-800 rounded text-sm text-blue-600 dark:text-blue-400 font-mono">{{ $route.path }}</code>
            is currently under active development.<br>
            Contact your admin
        </p>
        <router-link to="/"
            class="px-4 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors shadow-sm text-sm">
            Return to Dashboard
        </router-link>
    </div>
</template>

<script setup>
import { Vue3Lottie } from 'vue3-lottie'
// Replace with the relative path to your Lottie JSON file
import lottieBg from '@/assets/underConstruction.json' 
</script>